import React, { Component } from 'react'
import { connect } from 'react-redux'

// import styles
import './process.scss'

// Actions
import { getProcessTimeInformation, saveProcessTimeInformation } from '../../../actions/settings'

// Components
// import HelpText from '../../../shared/components/HelpText'
import DecimalInput from '../../../shared/components/DecimalInput'

import Col from '../../../shared/elements/col'
import Panel from '../../../shared/elements/panel'
import LabelWrapper from '../../../shared/elements/labelWrapper'
import Grid from '../../../shared/elements/grid'
import Text from '../../../shared/elements/text'
import Divider from '../../../shared/elements/divider'
import Null from '../../../shared/elements/null'
import BufferTimeDistribution from './BufferTimeDistribution'

// Utils
import { hasSubscriptionPermission } from '../../../utils/auth'
import { transformPercent } from '../../../utils/percent'
import { translation } from '../../../utils/helpers'

class Process extends Component {

  constructor (props) {
    super(props)
    this.gridCols = '1fr 96px 96px' // [ 1, 1, 1 ]
    this.state = {
      ShopId: 0,
      PaintShopProcess: undefined,
      BodyShopProcess: {
        SmallDamage: undefined,
        BigDamage: undefined,
        HourlyPrice: 0,
        DefaultMinutes: 0,
        MaterialPart: 0,
        BodyShopGainFactor: 0,
        SparePartShare: 0,
        BodyShopDefaultLeadTime: null
      },
      ProcessTimeOnOrderBrick: false
    }
    this.onChange = this.onChange.bind(this)
    this.onBodyShopChange = this.onBodyShopChange.bind(this)
    this.onBlur = this.onBlur.bind(this)
    this.onBodyShopBlur = this.onBodyShopBlur.bind(this)
    this.onDefaultLeadTimeChange = this.onDefaultLeadTimeChange.bind(this)
  }

  componentDidMount () {
    this.createTemplates()
    this.getProcessTimeInformation()
  }

  createTemplates () {
    let processTemplate = {
      ProcessTimes: [
        {
          CompanyId: 0,
          Fixed: 0,
          Variable: 0,
          share: 0,
          Step: 101,
          CompanyDepartment: 0,
          Id: 0
        },
        {
          CompanyId: 0,
          Fixed: 0,
          Variable: 0,
          share: 0,
          Step: 102,
          CompanyDepartment: 0,
          Id: 0
        },
        {
          CompanyId: 0,
          Fixed: 0,
          Variable: 0,
          share: 0,
          Step: 103,
          CompanyDepartment: 0,
          Id: 0
        },
        {
          CompanyId: 0,
          Fixed: 0,
          Variable: 0,
          share: 0,
          Step: 104,
          CompanyDepartment: 0,
          Id: 0
        }
      ]
    }
    this.setState({
      ShopId: 0,
      BodyShopProcess: {
        SmallDamageProcess: processTemplate,
        BigDamageProcess: processTemplate,
        HourlyPrice: 0,
        MaterialPart: 0,
        DefaultMinutes: 0,
        BigDamage: 0,
        BodyShopGainFactor: 0,
        SparePartShare: 0,
        BodyShopDefaultLeadTime: null
      },
      PaintShopProcess: {
        ProcessTimes: [
          {
            CompanyId: 0,
            Fixed: 0,
            Variable: 0,
            share: 0,
            Step: 2,
            CompanyDepartment: 0,
            Id: 0
          },
          {
            CompanyId: 0,
            Fixed: 0,
            Variable: 0,
            share: 0,
            Step: 3,
            CompanyDepartment: 0,
            Id: 0
          },
          {
            CompanyId: 0,
            Fixed: 0,
            Variable: 0,
            share: 0,
            Step: 4,
            CompanyDepartment: 0,
            Id: 0
          },
          {
            CompanyId: 0,
            Fixed: 0,
            Variable: 0,
            share: 0,
            Step: 5,
            CompanyDepartment: 0,
            Id: 0
          },
          {
            CompanyId: 0,
            Fixed: 0,
            Variable: 0,
            share: 0,
            Step: 6,
            CompanyDepartment: 0,
            Id: 0
          }
        ],
        ShareSum: 100,
        HourlyPrice: 0,
        MaterialPart: 0,
        GainFactor: 0,
        DefaultMinutes: 0,
        TimeOnWorkcard: false,
        PriceOnWorkcard: false
      }
    })
  }

  getProcessTimeInformation () {
    this.props.getProcessTimeInformation(this.props.auth.user.ShopId).then((res) => {
      let paintProcess = res.data.PaintShopProcess
      let bodyProcess = res.data.BodyShopProcess
      if (paintProcess !== null) {
        this.setState({
          ShopId: res.data.ShopId,
          PaintShopProcess: {
            ...this.state.PaintShopProcess,
            HourlyPrice: res.data.PaintShopProcess.HourlyPrice,
            MaterialPart: res.data.PaintShopProcess.MaterialPart,
            GainFactor: res.data.PaintShopProcess.GainFactor,
            DefaultMinutes: res.data.PaintShopProcess.DefaultMinutes,
            TimeOnWorkcard: res.data.PaintShopProcess.TimeOnWorkcard,
            PriceOnWorkcard: res.data.PaintShopProcess.PriceOnWorkcard,
            ProcessTimes: res.data.PaintShopProcess.ProcessTimes,
            ShareSum: res.data.PaintShopProcess.ShareSum
          }
        })
      }
      if (bodyProcess !== null) {
        this.setState({
          ShopId: res.data.ShopId,
          BodyShopProcess: {
            ...this.state.BodyShopProcess,
            SmallDamageProcess: {
              ProcessTimes: res.data.BodyShopProcess.SmallDamageProcess.ProcessTimes,
              ShareSum: res.data.BodyShopProcess.SmallDamageProcess.ShareSum
            },
            BigDamageProcess: {
              ProcessTimes: res.data.BodyShopProcess.BigDamageProcess.ProcessTimes,
              ShareSum: res.data.BodyShopProcess.BigDamageProcess.ShareSum
            },
            HourlyPrice: res.data.BodyShopProcess.HourlyPrice,
            MaterialPart: res.data.BodyShopProcess.MaterialPart,
            DefaultMinutes: res.data.BodyShopProcess.DefaultMinutes,
            BigDamage: res.data.BodyShopProcess.BigDamage,
            BodyShopGainFactor: res.data.BodyShopProcess.BodyShopGainFactor,
            SparePartShare: res.data.BodyShopProcess.SparePartShare,
            BodyShopDefaultLeadTime: res.data.BodyShopProcess.BodyShopDefaultLeadTime
          }
        })
      }
    }, (err) => {
      console.log(err)
    })
  }

  onChange (e) {
    if (e.persist) e.persist()
    let value = e.target.value
    if (e.target.type === 'radio') {
      value = (e.target.value === 'yes')
    }
    this.setState({
      PaintShopProcess: {
        ...this.state.PaintShopProcess,
        [e.target.name]: parseInt(value)
      }
    })
  }

  onBodyShopChange (e) {
    if (e.persist) e.persist()
    let value = e.target.value

    if (e.target.name === 'SparePartShare') {
      value = parseInt(value)
      if (isNaN(value)) {
        value = this.state.BodyShopProcess[e.target.name]
      }
      if (value < 0 || value > 100) {
        window.toastr.error(translation('15175'), translation('216'))
        if (value < 0) value = 0
        if (value > 100) value = 100
      }
    }
    this.setState({
      BodyShopProcess: {
        ...this.state.BodyShopProcess,
        [e.target.name]: value
      }
    })
  }

  onDefaultLeadTimeChange (e) {
    let value = e.target.value
    value = parseInt(value)

    if (isNaN(value)) {
      value = ''
    }
    if (value === '' || value < 1 || value > 99) {
      window.toastr.error(translation('18340'), translation('216'))
    }
    this.setState({
      BodyShopProcess: {
        ...this.state.BodyShopProcess,
        [e.target.name]: value
      }
    })
  }

  onBlur (e) {
    let allProcesses = {
      ShopId: this.state.ShopId,
      PaintShopProcess: this.state.PaintShopProcess
      // BodyShopProcess: this.state.BodyShopProcess
    }

    this.props.saveProcessTimeInformation(allProcesses).then((res) => {
      // Toastr (replace dict. key)
      if (res.data.PaintShopProcess.ShareSum === 100) {
        // window.toastr.success(translation('1713'), translation('13424'))
      } else {
        window.toastr.error(translation('1715'), translation('216'))
      }
      this.setState({
        PaintShopProcess: {
          ...this.state.PaintShopProcess,
          ShareSum: res.data.PaintShopProcess.ShareSum
        }
      })
    }, () => {
      // Toastr (replace dict. key)
      window.toastr.error(translation('1714'), translation('216'))
    })
  }

  onBodyShopBlur (e) {
    let processTime = {
      ShopId: this.state.ShopId,
      BodyShopProcess: this.state.BodyShopProcess
    }

    this.props.saveProcessTimeInformation(processTime).then((res) => {
      // Toastr (replace dict. key)
      if (res.data.Errors.length > 0) {
        let errors = res.data.Errors
        let errorText = ''
        errors.map((item) => {
          if (item.DictionaryKey !== 0) {
            errorText += '<br />' + translation(item.DictionaryKey)
          }
        })
        // Toastr
        window.toastr.error(translation(errorText), translation('216'))
      } else {
        if (res.data.BodyShopProcess.SmallDamageProcess.ShareSum === 100 && res.data.BodyShopProcess.BigDamageProcess.ShareSum === 100) {
          // window.toastr.success(translation('1713'), translation('13424'))
        } else {
          window.toastr.error(translation('1715'), translation('216'))
        }
      }
      this.setState({
        BodyShopProcess: {
          ...this.state.BodyShopProcess,
          SmallDamageProcess: {
            ...this.state.BodyShopProcess.SmallDamageProcess,
            ShareSum: res.data.BodyShopProcess.SmallDamageProcess.ShareSum
          },
          BigDamageProcess: {
            ...this.state.BodyShopProcess.BigDamageProcess,
            ShareSum: res.data.BodyShopProcess.BigDamageProcess.ShareSum
          },
          BodyShopDefaultLeadTime: res.data.BodyShopProcess.BodyShopDefaultLeadTime
        }
      })
    }, (err) => {
      console.log('err', err)
      if (err.response.data !== undefined && err.response.data.Errors !== undefined) {
        let errors = err.response.data.Errors
        let errorText = ''
        errors.map((item) => {
          if (item.DictionaryKey !== 0) {
            errorText += '<br />' + translation(item.DictionaryKey)
          }
        })
        // Toastr
        window.toastr.error(translation(errorText), translation('216'))
      } else {
        // Toastr
        window.toastr.error(translation('1714'), translation('216'))
      }
    })
  }

  render () {
    if (!hasSubscriptionPermission(this.props.auth, 20)) return null
    if (this.state.BodyShopProcess === undefined && this.state.PaintShopProcess === undefined) return null
    if (this.state.BodyShopProcess.SmallDamageProcess === undefined) return null
    if (this.state.BodyShopProcess.BigDamageProcess === undefined) return null

    let { PaintShopProcess } = this.state
    let { BodyShopProcess } = this.state

    let gainFactor = ''
    if (hasSubscriptionPermission(this.props.auth, 10, 19) || PaintShopProcess === null) {
      gainFactor = (
        <Text
          name='GainFactor'
          value={PaintShopProcess.GainFactor}
          onChange={this.onChange}
          onBlur={this.onBlur}
          labelText={translation('13484')}
          helpText={translation('1994')}
        />
      )
    }

    let bodyshopGainFactor = ''
    if (hasSubscriptionPermission(this.props.auth, 10, 19) || BodyShopProcess === null) {
      bodyshopGainFactor = (
        <Text
          name='BodyShopGainFactor'
          value={BodyShopProcess.BodyShopGainFactor}
          onChange={this.onBodyShopChange}
          onBlur={this.onBodyShopBlur}
          labelText={translation('13484')}
          helpText={translation('1994')}
        />
      )
    }

    return (
      <div>
        {(BodyShopProcess !== null && (this.props.auth.departmentType === 1 || this.props.auth.departmentType === 2)) && (
          <div>
            <Col span={'2'}>
              <Panel title={translation('788')}>
                <Null>
                  <div className='title'>
                    <img src='/images/svgs/bodyshop-steps/bodywork-2.svg' />
                    {translation('788')}
                  </div>
                </Null>

                <DecimalInput
                  name='SparePartShare'
                  value={BodyShopProcess.SparePartShare}
                  onChange={this.onBodyShopChange}
                  onBlur={this.onBodyShopBlur}
                  decimals={0}
                  transformValue={this.transformValue}
                  labelText={translation('15044') + ' (%)'}
                  helpText={translation('15110')}
                />
                <Divider />

                {this.renderSmallDamageProcessTimes()}
                {BodyShopProcess.SmallDamageProcess.ShareSum !== 100 && (
                  <Grid cols='1fr 96px' align='center'>
                    <span>{translation('1717')}</span>
                    <Text value={BodyShopProcess.SmallDamageProcess.ShareSum + '%'} disabled />
                  </Grid>
                )}
                <Divider noLine />
                {this.renderBigDamageProcessTimes()}
                {BodyShopProcess.BigDamageProcess.ShareSum !== 100 && (
                  <Grid cols='1fr 96px' align='center'>
                    <span>{translation('1717')}</span>
                    <Text value={BodyShopProcess.BigDamageProcess.ShareSum + '%'} disabled />
                  </Grid>
                )}

              </Panel>
              <Panel title={translation('18086')}>
                <BufferTimeDistribution />
              </Panel>
            </Col>

            <Col>
              <Panel title={translation('14782')}>
                {/* <Header text={translation('14782')} /> */}
                <Text
                  name='HourlyPrice'
                  value={BodyShopProcess.HourlyPrice}
                  onChange={this.onBodyShopChange}
                  onBlur={this.onBodyShopBlur}
                  labelText={translation('419')}
                  helpText={translation('1992')}
                />
                <DecimalInput
                  name='MaterialPart'
                  value={BodyShopProcess.MaterialPart}
                  onChange={this.onBodyShopChange}
                  onBlur={this.onBodyShopBlur}
                  decimals={0}
                  transformValue={this.transformValue}
                  labelText={translation('15045')}
                  helpText={translation('1993')}
                />
                <Text
                  name='DefaultMinutes'
                  value={BodyShopProcess.DefaultMinutes}
                  onChange={this.onBodyShopChange}
                  onBlur={this.onBodyShopBlur}
                  labelText={translation('13485')}
                  helpText={translation('1995')}
                />

                <Divider />
                {bodyshopGainFactor}
              </Panel>
            </Col>

            <Col>
              <Panel title={translation('18342')}>
                <Text
                  name='BodyShopDefaultLeadTime'
                  value={BodyShopProcess.BodyShopDefaultLeadTime}
                  onChange={this.onDefaultLeadTimeChange}
                  onBlur={this.onBodyShopBlur}
                  labelText={translation('503')}
                  />
              </Panel>
            </Col>
          </div>
        )}
        {(PaintShopProcess !== null && (this.props.auth.departmentType === 0 || this.props.auth.departmentType === 2)) && (
          <div>
            <Col span={'2'}>
              <Panel title={translation('161')}>
                <Null>
                  <div className='title'>
                    <img src='/images/svgs/workscreen/coating.svg' />
                    {translation('161')}
                  </div>
                </Null>

                {this.renderPaintShopProcessTimes()}
                {PaintShopProcess.ShareSum !== 100 && (
                  <Grid cols='1fr 96px' align='center'>
                    <span>{translation('1717')}</span>
                    <Text value={PaintShopProcess.ShareSum + '%'} disabled />
                  </Grid>
                )}

              </Panel>
            </Col>
            <Col>
              <Panel title={translation('14782')}>
                {/* <Header text={translation('14782')} /> */}
                <Text
                  name='HourlyPrice'
                  value={PaintShopProcess.HourlyPrice}
                  onChange={this.onChange}
                  onBlur={this.onBlur}
                  labelText={translation('419')}
                  helpText={translation('1992')}
                />
                <DecimalInput
                  name='MaterialPart'
                  value={PaintShopProcess.MaterialPart}
                  onChange={this.onChange}
                  onBlur={this.onBlur}
                  decimals={0}
                  transformValue={this.transformValue}
                  labelText={translation('13483')}
                  helpText={translation('1993')}
                />
                <Text
                  name='DefaultMinutes'
                  value={PaintShopProcess.DefaultMinutes}
                  onChange={this.onChange}
                  onBlur={this.onBlur}
                  labelText={translation('13485')}
                  helpText={translation('1995')}
                />

                <Divider />
                {gainFactor}

              </Panel>
            </Col>
          </div>
        )}
      </div>
    )
  }

  calcStepNameAndImage (step) {
    if (!step) return { stepName: step }

    switch (step) {
      case 101:
        return {
          stepName: translation('617'),
          image: '/images/svgs/workscreen/demount.svg'
        }
      case 102:
        return {
          stepName: translation('618'),
          image: '/images/svgs/workscreen/reparation.svg'
        }
      case 103:
        return {
          stepName: translation('619'),
          image: '/images/svgs/workscreen/mount.svg'
        }
      case 104:
        return {
          stepName: translation('162'),
          image: '/images/svgs/workscreen/clean.svg'
        }
    }
  }

  renderSmallDamageProcessTimes () {
    const renderProcessTime = (val, key) => {
      const onChange = (e) => {
        let processNew = { ...this.state.BodyShopProcess.SmallDamageProcess }
        if (e.target.value !== '') {
          let value = parseInt(e.target.value)
          if (value > 99999999) value = 99999999
          processNew.ProcessTimes[key][e.target.name] = value
        } else {
          processNew.ProcessTimes[key][e.target.name] = ''
        }
        this.setState({
          BodyShopProcess: {
            ...this.state.BodyShopProcess,
            SmallDamageProcess: processNew
          }
        })
      }

      const size = 'm'
      // console.log(this.calcStepNameAndImage(val.Step))
      const { stepName } = this.calcStepNameAndImage(val.Step)

      return (
        <Grid cols={this.gridCols} rowSpan='3' align='center' key={key}>
          <div>{stepName}</div>
          <Text name='Fixed' value={val.Fixed} onChange={onChange} onBlur={this.onBodyShopBlur} size={size} />
          <DecimalInput name='share' value={val.share} onChange={onChange} onBlur={this.onBodyShopBlur} decimals={0} transformValue={this.transformValue} size={size} />
        </Grid>
      )
    }

    return (
      <div>
        <Grid cols={this.gridCols} align='center'>
          <LabelWrapper labelText={translation('14828')}>
            <div className='undertext'>{`(${translation('15044')} <${this.state.BodyShopProcess.SparePartShare}%)`}</div>
          </LabelWrapper>
          <LabelWrapper labelText={translation('1195')} helpText={translation('1990')}>&#8203;</LabelWrapper>
          <LabelWrapper labelText={translation('1716') + ' (%)'} helpText={translation('1991')}>&#8203;</LabelWrapper>
        </Grid>
        {this.state.BodyShopProcess.SmallDamageProcess.ProcessTimes.map(renderProcessTime)}
      </div>
    )
  }

  renderBigDamageProcessTimes () {
    const renderProcessTime = (val, key) => {
      const onChange = (e) => {
        let processNew = { ...this.state.BodyShopProcess.BigDamageProcess }
        if (e.target.value !== '') {
          let value = parseInt(e.target.value)
          if (value > 99999999) value = 99999999
          processNew.ProcessTimes[key][e.target.name] = value
        } else {
          processNew.ProcessTimes[key][e.target.name] = ''
        }
        this.setState({
          BodyShopProcess: {
            ...this.state.BodyShopProcess,
            BigDamageProcess: processNew
          }
        })
      }

      const size = 'm'
      const { stepName } = this.calcStepNameAndImage(val.Step)

      return (
        <Grid cols={this.gridCols} rowSpan='3' align='center' key={key}>
          <div>{stepName}</div>
          <Text name='Fixed' value={val.Fixed} onChange={onChange} onBlur={this.onBodyShopBlur} size={size} />
          <DecimalInput name='share' value={val.share} onChange={onChange} onBlur={this.onBodyShopBlur} decimals={0} transformValue={this.transformValue} size={size} />
        </Grid>
      )
    }
    return (
      <div>
        <Grid cols={this.gridCols} align='center'>
          <LabelWrapper labelText={translation('14784')}>
            <div className='undertext'>{`(${translation('15044')} >${this.state.BodyShopProcess.SparePartShare}%)`}</div>
          </LabelWrapper>
          <LabelWrapper labelText={translation('1195')} helpText={translation('1990')}>&#8203;</LabelWrapper>
          <LabelWrapper labelText={translation('1716') + ' (%)'} helpText={translation('1991')}>&#8203;</LabelWrapper>
        </Grid>
        {this.state.BodyShopProcess.BigDamageProcess.ProcessTimes.map(renderProcessTime)}
      </div>
    )
  }

  renderPaintShopProcessTimes () {
    if (this.state.PaintShopProcess === null) return null
    const renderProcessTime = (val, key) => {
      const onChange = (e) => {
        let processNew = { ...this.state.PaintShopProcess }
        if (e.target.value !== '') {
          processNew.ProcessTimes[key][e.target.name] = parseInt(e.target.value)
        } else {
          processNew.ProcessTimes[key][e.target.name] = ''
        }
        this.setState({
          PaintShopProcess: processNew
        })
      }

      const size = 'm'

      let stepName = val.step
      // let image
      switch (val.Step) {
        case 2:
          stepName = translation('96')
          // image = '/images/svgs/workscreen/pretreatment.svg'
          break
        case 3:
          stepName = translation('160')
          // image = '/images/svgs/workscreen/filler.svg'
          break
        case 4:
          stepName = translation('158')
          // image = '/images/svgs/workscreen/sanding.svg'
          break
        case 5:
          stepName = translation('161')
          // image = '/images/svgs/workscreen/coating.svg'
          break
        case 6:
          stepName = translation('162')
          // image = '/images/svgs/workscreen/preparing.svg'
          break
      }

      return (
        <Grid cols={this.gridCols} rowSpan='3' key={key} align='center'>
          <div>{stepName}</div>
          <Text name='Fixed' value={val.Fixed} onChange={onChange} onBlur={this.onBlur} size={size} />
          <DecimalInput name='share' value={val.share} onChange={onChange} onBlur={this.onBlur} decimals={0} transformValue={this.transformValue} size={size} />
        </Grid>
      )
    }

    return (
      <div>
        <Grid cols={this.gridCols} align='center'>
          <LabelWrapper labelText={translation('946')} />
          <LabelWrapper labelText={translation('1195')} helpText={translation('1990')} />
          <LabelWrapper labelText={translation('1716') + ' (%)'} helpText={translation('1991')} />
        </Grid>
        {this.state.PaintShopProcess.ProcessTimes.map(renderProcessTime)}
      </div>
    )
  }

  transformValue (value, toClean) {
    return transformPercent(value, toClean)
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  getProcessTimeInformation,
  saveProcessTimeInformation
})(Process)



// WEBPACK FOOTER //
// ./src/app/pages/Settings/Process/index.js